/**
 * Sends a custom event to Microsoft Clarity. Does nothing when Clarity is blocked
 * or not loaded (local dev, ad blockers), so callers never need to guard.
 *
 * @param {string} name Event name, e.g. "empty_state_shown".
 * @param {!Object<string, (string|number|boolean|null|undefined)>=} tags Extra context,
 *     sent as Clarity session tags.
 */
export const trackEvent = (name, tags = {}) => {
  const clarity = typeof window !== "undefined" ? window.clarity : undefined;
  if (typeof clarity !== "function") return;
  try {
    Object.entries(tags).forEach(([key, value]) => {
      if (value !== undefined && value !== null) clarity("set", key, String(value));
    });
    clarity("event", name);
  } catch {
    // Analytics must never break the screen.
  }
};
